import moment from 'moment'

function ShipmentApiDetail(args) {
    const showDate = (actual, estimate, className) => {
        // The moment function creates a local time object. Since the 
        // raw date strings are Zulu time at midnight (i.e. they are
        // date-only), this generally yields a local time from the
        // previous day. The object must be converted to UTC explicitly,
        // to obtain the correct date.
        if (actual) return <span classname="${className}">{moment(actual).utc().format("yyyy-MM-DD")}</span>
        if (estimate) return <span><span class="est${className}">{moment(estimate).utc().format("yyyy-MM-DD")}</span> (est)</span>
        return '???'
    }

    let item = args.item

    return (<div className="shipment-details">
    <table className="detail">
        <tbody>
            <tr>
                <td>Shipper Number:</td>
                <td className="important"><strong><span class="shippernumber">{item.usercontrol}</span></strong></td>
            </tr>
            <tr>
                <td>Receiver Number:</td>
                <td className="important"><strong><span class="receivernumber">{item.receivernumber}</span></strong></td>
            </tr>
            <tr>
                <td>ShippersEdge TMS<sup>&trade;</sup> Number:</td>
                <td className="important"><strong><span class="bol">{item.webquotecontrol}</span></strong></td>
            </tr>
            <tr>
                <td>Status:</td>
                <td className="important"><strong><span class="statusdesc">{item.statusdesc}</span></strong></td>
            </tr>
            <tr>
                <td>Carrier:</td>
                <td className="important"><strong><span class="carriername">{item.carriername}</span></strong></td>
            </tr>
            {
                [0].map((n) => {
                    if (item.mode?.toUpperCase() == 'LTL') {
                        return (
                            <tr>
                                <td>Tracking Number:</td>
                                <td className="important"><strong><span class="trackingnumber">{item.pronum}</span></strong></td>
                            </tr>
                        )
                    }
                    return null
                })
            }
            <tr>
                <td>Route:</td>
                <td>
                    <table className="route">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="important">
                                        <strong>
                                            <span class="shipcity">{item.shipcity}</span>,&nbsp;
                                            <span class="shipstate">{item.shipstate}</span>
                                        </strong>
                                    </div>
                                    <div><span class="shipzip">{item.shipzip}</span></div>
                                    <div>P/U {showDate(item.pudate, item.estpudate, "pudate")}</div>
                                </td>
                                <td><strong>&rarr;</strong></td>
                                <td>
                                    <div className="important">
                                        <strong>
                                            <span class="conscity">{item.conscity}</span>,&nbsp;
                                            <span class="consstate">{item.consstate}</span>
                                        </strong>
                                    </div>
                                    <div><span class="conszip">{item.conszip}</span></div>
                                    <div>DEL {showDate(item.deldate, item.estdeldate, "deldate")}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
  </div>)

}

export default ShipmentApiDetail
